import React, {useState} from "react";
import styles from "./date-input.module.css";
import {addMessage, setWaitingResponse, setZodiacSign,} from "../../store/stateSlice";
import {useDispatch} from "react-redux";
import {findZodiacSign} from "../../../../util";
import {updateProfile} from "../../../../api";

const DateInput = ({ title }) => {
  const [answered, setAnswered] = useState(false);
  const [input, setInput] = useState("");

  const dispatch = useDispatch();

  const handleOnSend = () => {
    if (input) {
      const date = new Date(input);
      const zodiacSign = findZodiacSign(date.getDate(), date.getMonth());
      dispatch(setZodiacSign(zodiacSign));
      dispatch(addMessage(input));
      dispatch(setWaitingResponse());
      setAnswered(true);

      updateProfile({
        land: "tarot-chat",
        step: "step3",
        topicType: "birthDate",
        topic: title,
        answer: {
          day: date.getDate(),
          month: date.getMonth() + 1,
          year: date.getFullYear()
        }
      })
    }
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handleOnSend();
    }
  };

  return (
    <div className={styles.container}>
      <p className={styles.input_text}>{title}</p>
      {!answered && (
        <div className={styles.input_container}>
          <input
            type="date"
            value={input}
            onInput={(e) => setInput(e.target.value)}
            placeholder="Enter your birth date here..."
            className={styles.input}
            onKeyDown={handleEnter}
          />
          <button className={styles.button} onClick={handleOnSend}></button>
        </div>
      )}
    </div>
  );
};

export { DateInput };
